import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { api } from '@/lib/api/client';
import { ApiRoutes } from '@condo/contracts';
import { useAuth } from './use-auth';

interface UnidadHabitadaSummary {
  unidadId: string;
  unidadNumero: string;
}

/**
 * Returns the list of unidades the current user actively habita
 * (UnidadResidente.habita=true). Only meaningful for residente/propietario.
 * For admin/conserje/super_admin this returns an empty array — those roles
 * don't own "mi unidad" views; they use condominium-wide endpoints.
 */
export function useUnidadesHabitadas() {
  const { session } = useAuth();
  // condoId is available from URL params inside /app/condominios/:condoId/* routes.
  const { condoId } = useParams<{ condoId?: string }>();
  const effectiveRol = session
    ? condoId
      ? session.tenants[condoId]
      : undefined
    : undefined;
  const isResident =
    effectiveRol === 'residente' || effectiveRol === 'propietario';

  return useQuery({
    queryKey: ['unidades-habitadas', session?.userId],
    queryFn: () =>
      api.get<{ items: UnidadHabitadaSummary[] }>(
        ApiRoutes.misUnidadesHabitadas,
      ),
    enabled: isResident,
    select: (data) => data.items,
  });
}
